<template>
  <div class="pro_wrap">
    <ul class="pro_menu">
      <li>
        <p class="tit">
          <a>{{ $t('messages.pogopinProbe') }}</a>
        </p>
        <ul :class="['deap2', { on: showMenusIndex == 1 }]">
          <div class="list-container">
            <div style="min-width: 200px;">
              <li>
                <router-link to="/Pogopin_Single">{{ $t('messages.pogpinSingle') }}</router-link>
              </li>
              <li>
                <router-link to="/Pogopin_Connector">{{ $t('messages.pogopinConnector') }}</router-link>
              </li>
              <li>
                <router-link to="/Pogopin_Waterproof">{{ $t('messages.pogopinWaterpoofConnector') }}</router-link>
              </li>
              <li>
                <router-link to="/Pogopin_Magnetic">{{ $t('messages.pogopinMagneticConnector') }}</router-link>
              </li>
            </div>
            <div class="image-container">
              <el-image
                src="https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/home/our_products/pogopin_icon.png"></el-image>
            </div>
          </div>




        </ul>
      </li>
      <li class>
        <p class="tit">
          <a @click="switchShowMenu(2)" :data-content="$t('messages.productsTitleMore')">{{ $t('messages.TestingProbes')
            }}</a>
        </p>
        <ul :class="['deap2', { on: showMenusIndex == 2 }]">
          <div class="list-container">
            <div style="min-width: 200px;">
              <li>
                <router-link to="/TestingProbes_ICT">{{ $t('messages.ictProbe') }}</router-link>
              </li>
              <li>
                <router-link to="/TestingProbes_IC_Test">{{ $t('messages.icProbe') }}</router-link>
              </li>
              <li>
                <router-link to="/TestingProbes_HightCurrent">{{ $t('messages.highCurrentTestProbe') }}</router-link>
              </li>
            </div>
            <div class="image-container">
              <el-image
                src="https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/home/our_products/test_icon.png"></el-image>
            </div>
          </div>

        </ul>
      </li>
      <li>
        <p class="tit">
          <a @click="switchShowMenu(3)" :data-content="$t('messages.productsTitleMore')">{{ $t('messages.connectors')
            }}</a>
        </p>
        <ul :class="['deap2', { on: showMenusIndex == 3 }]">
          <div class="list-container">
            <div style="min-width: 200px;">
              <li>
                <router-link to="/IndustryConnector_PlugSocket">{{ $t('messages.pinSocketTerminal') }}</router-link>
              </li>
              <li>
                <router-link to="/IndustryConnector_Circular">{{ $t('messages.roundConnector') }}</router-link>
              </li>
              <li>
                <router-link to="/IndustryConnector_Rectangular">{{ $t('messages.rectangularConnector') }}</router-link>
              </li>
            </div>
            <div class="image-container">
              <el-image
                src="https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/home/our_products/connector_icon.png"></el-image>
            </div>

          </div>

        </ul>
      </li>
      <li class>
        <p class="tit">
          <a @click="switchShowMenu(4)" :data-content="$t('messages.productsTitleMore')">{{ $t('messages.MetalParts')
            }}</a>
        </p>
        <ul :class="['deap2', { on: showMenusIndex == 4 }]">
          <div class="list-container">
            <div style="min-width: 200px;">
              <li>
                <router-link to="/HardwareComponents_Communication">{{ $t('messages.communicationShaftParts')
                  }}</router-link>
              </li>
              <li>
                <router-link to="/HardwareComponents_Medical">{{ $t('messages.medicalDeviceShaftParts') }}</router-link>
              </li>
              <li>
                <router-link to="/HardwareComponents_AeroSpace">{{ $t('messages.aerospaceComplexParts') }}</router-link>
              </li>
            </div>
            <div class="image-container">
              <el-image
                src="https://mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.cdn.bspapp.com/Resource/home/our_products/wujin_icon.png"></el-image>
            </div>
          </div>

        </ul>
      </li>
      <!-- <li>
        <p class="tit">
          <a @click="switchShowMenu(5)">Medical Solutions</a>
        </p>
        <ul :class="['deap2', { on: showMenusIndex == 5 }]">
          <li>
            <a href="./products/flexible-pcb-for-catheter-application/">Flexible PCB for Catheter Application</a>
          </li>
          <li>
            <a href="./products/other-medical-components/">Other Medical Components</a>
          </li>
        </ul>
      </li> -->
      <!-- <li>
        <p class="tit">
          <a @click="switchShowMenu(6)">Others</a>
        </p>
        <ul :class="['deap2', { on: showMenusIndex == 6 }]">
          <li>
            <a href="./products/memory-module-test-socket/">Memory Module Test Socket</a>
          </li>
          <li>
            <a href="./products/module-connector-test-socket-probe/">Module Connector Test Socket &amp; Probe</a>
          </li>
          <li>
            <a href="./products/battery-charging-discharging-probes/">Battery Charging &amp; Discharging Probe</a>
          </li>
        </ul>
      </li> -->
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOn: false,
      showMenusIndex: -1
    };
  },
  computed: {
    isShowMenu() {
      return this.isOn ? "on" : "";
    }
  },

  methods: {
    switchShowMenu(index) {
      this.showMenusIndex = index;
    }
  }
};
</script>

<style scoped>
.pro_wrap {
  margin-top: 74px;
}

.pro_menu {
  margin-top: 74px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 49px 0;
  padding: 70px;
  margin: 0px;
}

.pro_menu>li {
  border: 3px dashed rgba(0, 87, 156, 0.15);
  border-width: 0 3px 0 3px;
}

.pro_menu li {
  list-style: none;
}

.pro_menu .tit {
  padding: 0;
  margin: 0;
}

.pro_menu li.on .tit a {
  padding-bottom: 0.5em;
}

.pro_menu .tit a {
  position: relative;
  font-size: 28px;
  font-weight: 700;
  display: block;
  padding: 3rem 6rem 3rem 2.5rem;
  background: #fff;
  border: none;
  /* width: 100%; */
  text-align: left;
  cursor: pointer;
}

.pro_menu .tit a:hover {
  background: #dfe5eb;
}

.pro_menu li a {
  text-decoration: none;
  color: #00579c;
}

/* .pro_menu .tit a:after {
  content: attr(data-content);
  display: inline-block;
  margin: 0;
  background: rgba(41, 81, 124, 0.15);
  border-radius: 5px;
  padding: 0 1em;
  line-height: 28px;
  height: 28px;
  font-size: 14px;
  vertical-align: middle;
  position: absolute;
  right: 3em;
  top: 53px;
} */

.pro_menu .deap2.on {
  display: block;
}

.pro_menu .deap2 {
  /* display: none;
  margin: 0;
  background: #dfe5eb;
  padding-bottom: 2em; */
  display: block;
}

.pro_menu .deap2 li {
  margin-bottom: 5px;
}

.list-container {
  display: flex;
  flex-direction: row;
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: center;

}

.pro_menu .deap2 li a {
  display: block;
  position: relative;
  padding: 0.1em 0;
  font-size: 20px;
}

.pro_menu .deap2 li a:hover {
  color: #0077b4;
}
</style>


// WEBPACK FOOTER //
// src/components/CategoryMenu.vue